import script from "./BrandChannelContent.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandChannelContent.vue?vue&type=script&setup=true&lang=js"

import "./BrandChannelContent.vue?vue&type=style&index=0&id=10149cbb&lang=css"

const __exports__ = script;

export default __exports__